export class BannerImage {
  id: string;
  url: string;

  constructor(data: any) {
    this.id = data.sys.id;
    this.url = data.fields.file.url;
  }
}
